import _ from 'lodash';
import { apiWrapper } from './helpers';
import GLOBAL from '../configs/config_global';

export function getCityList() {
    return new Promise((resolve) => {
        apiWrapper('/consumer/v1/city', 'GET', 'GET CITY LIST')
            .then((result) => {
                // Put all cities into their states
                const obj = {};
                const cityObj = {};
                result.forEach((city) => {
                    // Generate new city data object
                    const newCityData = _.pick(city, ['id', 'name', 'image', 'image_webp', 'slug', 'is_coming_soon', 'is_vendor_available', 'require_license_number', 'state']);

                    // Add center coordinates
                    newCityData['coordinates'] = {
                        'latitude': Number(city['lat']) || 39.7645183,
                        'longitude': Number(city['long']) || -104.9955371,
                        'latitudeDelta': 0.008,
                        'longitudeDelta': 0.007
                    };

                    // Add require_license_number flag
                    newCityData['requireLicenseNumber'] = !!newCityData['require_license_number'];

                    // Add enabled featured sections
                    newCityData['showBreweries'] = Number(city['show_breweries']) === 1;
                    newCityData['showActivities'] = Number(city['show_activities']) === 1;

                    // Only pick the ones marked as available
                    if (newCityData['is_vendor_available'] === 1) {
                        // Push to cities object
                        cityObj[city.id] = newCityData;

                        // Push to grouped states object
                        if (!obj.hasOwnProperty(city.state.id)) {
                            obj[city.state.id] = { ...city.state, cityList: [newCityData] };
                        }
                        else obj[city.state.id].cityList.push(newCityData);
                    }
                });

                // Parse to array
                const returningArr = Object.values(obj);

                // Sort alphabetically state names
                returningArr.sort((a, b) => a.name.localeCompare(b.name));

                // Sort alphabetically city names
                returningArr.forEach((item) => item.cityList.sort((a, b) => a.name.localeCompare(b.name)));

                // Save to global
                GLOBAL.CITIES = cityObj;
                GLOBAL.GROUPED_STATES = returningArr;

                // Resolve
                resolve(returningArr);
            })
            .catch(() => resolve([]));
    });
}
